export const REPORTS_TRANSLATIONS = {
  Reports: "Informes",

  lastReports: "Últimos {{count}} informes",
  lastReports_zero: "No hay informes disponibles",
  lastReports_one: "Último informe",

  report_type_farm_animals: "Informe General de Animales",
  report_type_individual_animal: "Informe Individual de Animal",
  report_type_farm: "Informe de Granja",
  report_type_apiary: "Informe de Colmenar",
  report_type_crops: "Informe de Cultivos",
  newReport: "Nuevo Informe",
  download: "Descargar",
  view: "Ver",
  generateReport: "Generar Informe",
}
